/**
 * OCC (optimistic-concurrency) baseline helpers for the single-record screen.
 */

/**
 * The OCC baseline (record_version) to adopt after a SUCCESSFUL own save.
 *
 * The next edit's lost-update guard must baseline from the version the server
 * just stored, not the version the edit started from. Normally the pristine-gated
 * version-tracking effect re-arms the baseline when STORE_RESOURCE_DATA advances
 * the store version — but when the server REWROTE the submitted body on save
 * (e.g. PYTHON_AUTOFORMAT_MODE=always rewriting single -> double quotes), the form
 * is transiently kept dirty by keepDirtyOnReinitialize during that store-update
 * render (submitted body !== stored body), so the effect runs while still dirty,
 * skips the re-arm, and never re-fires (the version has already settled). The
 * baseline then stays frozen at the pre-save token and the NEXT save false-trips
 * the OCC "someone else changed the record" 409. Adopting the server-returned
 * record_version here closes that race deterministically.
 *
 * Falls back to the current baseline when the saved record exposes no
 * record_version (record types without a modified_at token keep last-write-wins).
 * See operator-task-fe-autoformat-on-save-spurious-record-changed-and-quote-revert.
 */
export const occBaselineAfterSave = (
    savedRecord: { record_version?: string } | undefined | null,
    currentBaseline: string | undefined
): string | undefined => savedRecord?.record_version ?? currentBaseline;
